"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.overview")
    .config(["$stateProvider", routeConfig]);

function overviewLazyLoad(transition) {
    const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
    return import(
        /* webpackChunkName: "feature-accounting-overview" */ "./accounting-overview.entry"
    ).then(() =>
        Promise.all([
            $ocLazyLoad.inject("nucont.accounting.overview"),
            $ocLazyLoad.inject("nucont.accounting.contactsManagment")
        ])
    );
}

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.overview", {
            url: "/visaogeral",
            params: {},
            lazyLoad: overviewLazyLoad,
            views: {
                "admin@nucont.accounting": {
                    component: "accountingOverviewViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.dashboard", {
            url: "/dashboard",
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            },
            params: {},
            views: {
                "submodules@nucont.accounting.overview": {
                    component: "accountingDashboardViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.portfolio", {
            url: "/carteira",
            params: {},
            views: {
                "submodules@nucont.accounting.overview": {
                    component: "accountingPortfolioViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.monitoring", {
            url: "/monitoramento/:source?accountPlanType",
            params: {
                source: {
                    value: null,
                    dynamic: true
                },
                accountPlanType: {
                    value: null,
                    dynamic: true
                }
            },
            views: {
                "submodules@nucont.accounting.overview": {
                    component: "monitoringViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "searchInput.placeholder",
                            value: "Procurar nome ou CNPJ da empresa…"
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.overview.monitoring.audit", {
            url: "/auditoria",
            views: {
                "tableContentView@nucont.accounting.overview.monitoring": {
                    component: "accountingAuditViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.monitoring.health", {
            url: "/objetivos",
            views: {
                "tableContentView@nucont.accounting.overview.monitoring": {
                    component: "monitoringHealthViewComponent"
                }
            }
        });
}
